import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';
import { removeTemplate } from 'store/entities/templates/templates';

const TemplateDeleteModal = ({ entity, templateId, templates, setModalVisible, removeTemplate }) => {
  const { t } = useTranslation();
  const { company: companyId } = useParams();

  const onClose = () => setModalVisible(false);
  const onDelete = () => {
    removeTemplate(templateId, templates, entity, companyId);
    setModalVisible(false);
  };

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: t(translations.settings_deleteAutomationRuleset),
          content: <>{t(translations.settings_areYouSureYouWantToDeleteThisRuleset)}</>,
          footer: (
            <>
              <Button testId="delete-modal-button-delete" label={t(translations.delete)} colored onClick={onDelete} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapDispatchToProps = { removeTemplate };

const Container = connect(null, mapDispatchToProps)(TemplateDeleteModal);

export { Container as TemplateDeleteModal };
